module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tech-items"
  }, [_c('div', {
    staticClass: "item-tech"
  }, [_vm._m(0), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions1
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_vm._m(1), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions2
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_vm._m(2), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions3
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-video-camera",
    staticStyle: {
      "color": "#25335e",
      "font-size": "30px",
      "position": "relative",
      "top": "4px"
    }
  }), _vm._v(" "), _c('i', [_vm._v("【世说”新“语】Newords.2025——程力真老师专访")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-video-camera",
    staticStyle: {
      "color": "#25335e",
      "font-size": "30px",
      "position": "relative",
      "top": "4px"
    }
  }), _vm._v(" "), _c('i', [_vm._v("【世说”新“语】Newords.2025——陈俊老师专访")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-video-camera",
    staticStyle: {
      "color": "#25335e",
      "font-size": "30px",
      "position": "relative",
      "top": "4px"
    }
  }), _vm._v(" "), _c('i', [_vm._v("【世说”新“语】Newords.2025——张嵩老师专访")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f22659f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Interview.vue
// module id = 614
// module chunks = 1